import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class LocalaccountService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  localAccountData: any;

  private localAccountHeroSubject$ = new BehaviorSubject<any>(null);
  public localAccountHero$ = this.localAccountHeroSubject$.asObservable();
  private localAccountCustomerStatsSubject$ = new BehaviorSubject<any>(null);
  public localAccountCustomerStats$ =
    this.localAccountCustomerStatsSubject$.asObservable();
  private localAccountFeaturePanel1Subject$ = new BehaviorSubject<any>(null);
  public localAccountFeaturePanel1$ =
    this.localAccountFeaturePanel1Subject$.asObservable();
  private localAccountFeaturePanel2Subject$ = new BehaviorSubject<any>(null);
  public localAccountFeaturePanel2$ =
    this.localAccountFeaturePanel2Subject$.asObservable();
  private localAccountVideoPanelSubject$ = new BehaviorSubject<any>(null);
  public localAccountVideoPanel$ =
    this.localAccountVideoPanelSubject$.asObservable();
  private localAccountCustomerStoryPanelSubject$ = new BehaviorSubject<any>(
    null
  );
  public localAccountCustomerStoryPanel$ =
    this.localAccountCustomerStoryPanelSubject$.asObservable();
  private localAccountDiscoverDifferencePanelSubject$ =
    new BehaviorSubject<any>(null);
  public localAccountDiscoverDifferencePanel$ =
    this.localAccountDiscoverDifferencePanelSubject$.asObservable();
  private localAccountWhitePaperPanelSubject$ = new BehaviorSubject<any>(null);
  public localAccountWhitePaperPanel$ =
    this.localAccountWhitePaperPanelSubject$.asObservable();
  private localAccountPricingPanelSubject$ = new BehaviorSubject<any>(null);
  public localAccountPricingPanel$ =
    this.localAccountPricingPanelSubject$.asObservable();
  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();

  getlocalAccountPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.solutionsPage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.localAccountData = mod.filter(
          x => x?.fields['id'] == PageId.localAccountPage
        );

        const heroData = this.localAccountData[0].fields.psHeroPanel.fields;
        if (heroData) {
          this.localAccountHeroSubject$.next(heroData);
        }
        const customerStats =
          this.localAccountData[0].fields.psCustomerStatsContentPanel.fields;
        if (customerStats) {
          this.localAccountCustomerStatsSubject$.next(customerStats);
        }
        const featurePanel1 =
          this.localAccountData[0]?.fields?.psFeatures[0]?.fields;
        if (featurePanel1) {
          this.localAccountFeaturePanel1Subject$.next(featurePanel1);
        }
        const featurePanel2 =
          this.localAccountData[0]?.fields?.psOtherProductsPanel?.fields;
        if (featurePanel2) {
          this.localAccountFeaturePanel2Subject$.next(featurePanel2);
        }
        const videoPanel =
          this.localAccountData[0]?.fields?.psProductVideo?.fields;
        if (videoPanel) {
          this.localAccountVideoPanelSubject$.next(videoPanel);
        }
        const customerStoryPanel =
          this.localAccountData[0]?.fields?.psCustomerStories?.fields;
        if (customerStoryPanel) {
          this.localAccountCustomerStoryPanelSubject$.next(customerStoryPanel);
        }
        const discoverDifferencePanel =
          this.localAccountData[0]?.fields?.psTableFeaturesComparison?.fields;
        if (discoverDifferencePanel) {
          this.localAccountDiscoverDifferencePanelSubject$.next(
            discoverDifferencePanel
          );
        }
        const whitePaperPanel =
          this.localAccountData[0]?.fields?.psWhitepaperForm?.fields;
        if (whitePaperPanel) {
          this.localAccountWhitePaperPanelSubject$.next(whitePaperPanel);
        }
        const pricingPanel =
          this.localAccountData[0]?.fields?.psPricingPanel?.fields;
        if (pricingPanel) {
          this.localAccountPricingPanelSubject$.next(pricingPanel);
        }
        const getStarted =
          this.localAccountData[0].fields.psGetStartedPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
      });
  }
}
